import util from '../util';

export const CURRENT_USER_PERMISSIONS = 'CURRENT_USER_PERMISSIONS';
export const USER_ROLES = 'USER_ROLES';

export const CURRENT_USER_PERMISSIONS_REQUEST = util.requestType(
  CURRENT_USER_PERMISSIONS,
);
export const CURRENT_USER_PERMISSIONS_SUCCESS = util.successType(
  CURRENT_USER_PERMISSIONS,
);
export const CURRENT_USER_PERMISSIONS_FAILURE = util.failureType(
  CURRENT_USER_PERMISSIONS,
);

export const USER_ROLES_REQUEST = util.requestType(USER_ROLES);
export const USER_ROLES_SUCCESS = util.successType(USER_ROLES);
export const USER_ROLES_FAILURE = util.failureType(USER_ROLES);
